// Detail značky (issue #32, screens/18-znacky.md „Detail značky" + „Mobilní odchylky").
//
// Výpis samotný sdílí markup s kategorií, staví ho categoryPage.js (#13),
// listingTools.js a mobileFilter.js (#14) — tenhle modul dodává jen to, co má
// značka navíc:
//   • hlavičku značky `.bs-bhero` (wordmark box, H1 + počet, perex, trust chipy);
//     `.bs-cat-head` i `.bs-cat-perex` se do panelu PŘESOUVAJÍ, ne kopírují
//   • tmavý panel servisu značky — do sidebaru pod filtr, na mobilním renderu
//     (bez sidebaru) na konec výpisu
//
// Nativní DOM: `main#content > div.manufacturerDetail` (h1 + odstavce popisu)
// a hned za ním sourozenci `#category-header`, `#products`, `.listingControls`.
//
// VYPUŠTĚNO proti designu: pás kategorií značky a sekce „Kategorie značky" ve
// filtru. Nativní `#filters` na `/znacka/<slug>/` má jen cenu, dostupnost
// a štítky — kategorie tam Shoptet nenabízí a produktové karty ji nenesou,
// takže pilulky by neměly ani počty, ani cílovou URL. Stejně jako u log značek
// je to čekání na data, ne designové rozhodnutí.
//
// Idempotentní, re-init po AJAX překreslení (ShoptetDOMPageContentLoaded).

import { icon } from './icon.js';
import { page } from './pages.js';
import L from '../locale/cs/brandDetail.js';

const READY = 'bs-brand-ready';

// Texty → locale vrstva (S3 #399); dluh per soubor měří tools/lib/locale-debt.mjs
const LABEL_CHIP_SERVICE = L.chipService;
const LABEL_CHIP_WARRANTY = L.chipWarranty;

// Tmavý panel servisu (design „Díly ONDRAGON skladem")
const SERVICE = {
  eyebrow: L.serviceEyebrow,
  title_pre: L.serviceTitlePre,
  title_post: L.serviceTitlePost,
  text: L.serviceText,
  cta: L.serviceCta,
  href: page('service'),
};

function el(tag, cls, txt) {
  const node = document.createElement(tag);
  if (cls) node.className = cls;
  if (txt != null) node.textContent = txt;
  return node;
}

function isBrandDetail() {
  return document.body.classList.contains('type-manufacturer-detail');
}

function text(node) {
  return ((node && node.textContent) || '').replace(/\s+/g, ' ').trim();
}

export function brandName() {
  const h1 = document.querySelector('.manufacturerDetail h1') || document.querySelector('#content h1');
  return text(h1);
}

// Počet skladem = nativní `.filter-count` u dostupnostního filtru (reálné číslo,
// Shoptet ho přepočítává); když filtr chybí, chip se vynechá.
function stockCount() {
  const label = document.querySelector('#filters label[for="stock"] .filter-count');
  const n = parseInt((text(label) || '').replace(/\D/g, ''), 10);
  return isFinite(n) ? n : null;
}

// ---------------------------------------------------------------------------
// Hlavička značky (design „Hlavička značky")
// ---------------------------------------------------------------------------
function buildChips() {
  const chips = el('div', 'bs-bhero__chips');
  const defs = [];

  const stock = stockCount();
  if (stock != null) defs.push({ icon: 'package', label: L.stockLabel(stock) });
  defs.push({ icon: 'wrench', label: LABEL_CHIP_SERVICE });
  defs.push({ icon: 'shield', label: LABEL_CHIP_WARRANTY });

  defs.forEach(function (def) {
    const chip = el('span', 'bs-bhero__chip');
    chip.appendChild(icon(def.icon));
    chip.appendChild(el('span', null, def.label));
    chips.appendChild(chip);
  });
  return chips;
}

function buildHero() {
  const intro = document.querySelector('.manufacturerDetail');
  const head = document.querySelector('.bs-cat-head');
  if (!intro || !head || document.querySelector('.bs-bhero')) return;

  const name = brandName();
  const hero = el('div', 'bs-bhero');
  hero.appendChild(el('span', 'bs-bhero__mark', name));

  const body = el('div', 'bs-bhero__body');
  hero.appendChild(body);
  head.insertAdjacentElement('beforebegin', hero);

  body.appendChild(head);

  // perex staví categoryPage.js z prvního odstavce popisu (+ mobilní přepínač)
  const perex = intro.querySelector('.bs-cat-perex');
  if (perex) {
    const toggle = perex.nextElementSibling;
    body.appendChild(perex);
    if (toggle && toggle.classList.contains('bs-cat-perex__toggle')) body.appendChild(toggle);
  }

  body.appendChild(buildChips());
}

// ---------------------------------------------------------------------------
// Tmavý panel servisu značky
// ---------------------------------------------------------------------------
function buildService() {
  if (document.querySelector('.bs-bservice')) return;

  // desktop: pod filtr v sidebaru · mobilní render sidebar nemá → konec výpisu
  const col = document.querySelector('.bs-filter-col');
  const host = col || document.querySelector('.bs-listing__main');
  if (!host) return;

  const panel = el('div', 'bs-bservice');
  panel.appendChild(el('span', 'bs-bservice__eyebrow', SERVICE.eyebrow));
  panel.appendChild(el('span', 'bs-bservice__title', SERVICE.title_pre + brandName() + SERVICE.title_post));
  panel.appendChild(el('p', 'bs-bservice__text', SERVICE.text));

  const cta = el('a', 'bs-bservice__cta');
  cta.href = SERVICE.href;
  cta.appendChild(el('span', null, SERVICE.cta));
  cta.appendChild(icon('wrench'));
  panel.appendChild(cta);

  host.appendChild(panel);
}

// ---------------------------------------------------------------------------

export function initBrandDetail() {
  if (!isBrandDetail()) return;
  if (!document.querySelector('.manufacturerDetail')) return;

  buildHero();
  buildService();

  document.documentElement.classList.add(READY);
}
